import React, { useContext, useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { MdDeleteOutline, MdDownload } from "react-icons/md";
import { useAppSelector } from "../../utils/redux/hooks";
import { RootState } from "../../utils/redux/store";
import Scrollbar from "../../components/scrollbar";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingModal } from "../../utils/context/loading";
import { useDispatch } from "react-redux";
import {
  addcustomers,
  addisLoading,
  addreferralsByUser,
  adduserData,
  addviewCustomer,
} from "../../utils/redux/mainSlice";
import { getCustomers, getReferralsByID, getUser } from "../../utils/apis/func";

const Index2 = () => {
  const referralsByUser = useAppSelector(
    (store: RootState) => store.user.referralsByUser
  );
  const [searchTerm, setSearchTerm] = useState("");
  const searchFullName = (data: any[], searchTerm: string) => {
    if (!searchTerm) {
      return data; // Return all data when searchTerm is empty
    }
    const searchTermLower = searchTerm?.toLowerCase();
    return data.filter((item) =>
      `${item.fullName}`
        .toLowerCase()
        ?.includes(searchTermLower)
    );
  };
  const filteredServices = searchFullName(referralsByUser, searchTerm);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalItems = referralsByUser?.length;

  const allItems = Array.from({ length: itemsPerPage }, (_, index) => ({
    id: index + 1,
    name: `First Last ${index + 1}`,
    phoneNumber: `0805214256${index}`,
    email: `example${index}@example.com`,
    dob: `12/02/1991`,
    gender: `female`,
    address: `24, Nana Avenue, Sangotedo, Lagos`,
    nationality: `Nigerian`,
  }));

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = referralsByUser?.slice(startIndex, endIndex);

  const data = { endIndex, allItems };
  // const itemsToShow = allItems?.slice(startIndex, endIndex);
  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const [actionModal, setIsActionModal] = useState(false);

  const toggleActionModal = () => {
    setIsActionModal(!actionModal);
  };

  const navigate = useNavigate();

  const [initState, setInitState] = React.useState(
    useContext(LoadingModal).initState
  );

  const dispatch = useDispatch();

  const query = useParams();
  console.log(query?.id);

  useEffect(() => {
    setInitState(true);

    console.log(initState);
    const fetchReferrals = async () => {
      dispatch(addisLoading(true));
      const res: any = await getReferralsByID(`${query?.id}`);
      console.log("res-res", res?.data?.data?.[0]);
      if (res?.status === 200 || res?.status === 201) {
        if (res?.data?.data?.[0]?.totalReferrals > 0) {
          dispatch(addreferralsByUser(res?.data?.data?.[0]?.referredUsers));
        }
      }
      dispatch(addisLoading(false));
    };
    fetchReferrals();

    setInitState(false);
  }, [dispatch, initState]);

  return (
    <>
      <div className="relative overflow-x-auto  px-3">
        <div className="mb-4">
          <div className="ml-10 flex items-center sm:flex ">
            <FaSearch className="text-[#88087B]" />
            <input
              type="text"
              className=" rounded-full ml-4 px-4 py-2 sm:w-48 lg:w-70 font-roboto text-sm font-normal leading-5 tracking-tighter text-[#8E8E93] focus:outline-none"
              placeholder="Search Refferals"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                searchFullName(referralsByUser, e.target.value);
              }}
            />
          </div>
        </div>
        <>
          <div className="overflow-x-auto rounded-t-lg">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 px-3">
              <thead className="bg-[#88087B] py-4 px-2 sm:px-10 text-[#F7F7F7] font-roboto text-sm lg:text-lg font-medium leading-normal rounded-t-lg">
                <tr>
                  <th scope="col" className="px-6 py-3 text-base">
                    Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-base">
                    Email
                  </th>
                  <th scope="col" className="px-6 py-3 text-base">
                    Account Type
                  </th>
                  <th scope="col" className="px-6 py-3 text-base">
                    State
                  </th>
                  <th
                    scope="col"
                    className="px-6 border-none py-3 text-base"
                  ></th>
                </tr>
              </thead>
              <tbody>
                {(searchTerm.length === 0
                  ? itemsToShow
                  : filteredServices
                )?.map((item) => (
                  <tr
                    onClick={() => {
                      navigate(`/customers/${item?.id || item?._id}`);
                      dispatch(addviewCustomer(item));
                    }}
                    className="py-4 px-2 sm:px-20 hover:bg-[#87878d] text-black transition duration-300 font-roboto text-xs font-medium leading-normal items-center"
                  >
                    <td className=" flex text-center px-10 py-4">
                      {/* <MdCheckBoxOutlineBlank
                        size={20}
                        className="-ml-8 mr-4 text-[#BEBECA] rounded-lg"
                      /> */}
                      <span className="whitespace-nowrap">
                        {item?.fullName ||
                          `${item?.firstName} ${item?.lastName}`}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {" "}
                      {item?.email}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {" "}
                      {item?.accountType}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {" "}
                      {item?.state}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Scrollbar
            currentPage={currentPage}
            totalPages={Math.ceil(totalItems / itemsPerPage)}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            onPrevPageClick={handlePrevPageClick}
            onNextPageClick={handleNextPageClick}
          />
        </>

        {actionModal && (
          <>
            <div className="flex flex-col gap-8 w-[10rem] p-4 absolute top-44 right-[30rem] z-50 rounded-md border border-[#88087B] bg-[#fff]">
              <p className="flex gap-2 items-center font-bold cursor-pointer">
                <MdDownload size={25} className="" />
                Export
              </p>
              <p className="flex gap-2 items-center text-[#D11C1C] font-bold cursor-pointer">
                <MdDeleteOutline size={25} className="text-[#D11C1C]" />
                Delete
              </p>
            </div>
          </>
        )}
      </div>

      {/* { showDeleteConfirmation && <DeleteConfirmationModal/> } */}
    </>
  );
};

export default Index2;
